var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function ScaleResizeIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 19V5H5V12H11.0025C11.5534 12 12 12.4463 12 12.9975V19H19ZM3 3.99985C3 3.44765 3.44495 3 3.99985 3H20.0001C20.5524 3 21 3.44495 21 3.99985V20.0001C21 20.5524 20.5551 21 20.0001 21H3.99985C3.44765 21 3 20.5551 3 20.0001V3.99985ZM5 14V19H10V14H5Z", fill: "" })));
}
export var ScaleResizeIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: ScaleResizeIconInner }, props))); };
//# sourceMappingURL=ScaleResizeIcon.js.map